import React from 'react'
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

const Header = () => {
    const location = useLocation();
    const [isBrokerModalOpen, setIsBrokerModalOpen] = useState(false);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    const [Home, setHome] = useState(false);
    const [FindAnAgent, setFindAnAgent] = useState(false);
    const [Events, setEvents] = useState(false);
    const [Locations, setLocations] = useState(false);
    const [Medicare, setMedicare] = useState(false);
    const [About, setAbout] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const path = location.pathname;
        if (path === '/') { }
        else if (path === '/FindAgent') { setHome(!Home); setFindAnAgent(!FindAnAgent); }
        else if (path === '/events') { setHome(!Home); setEvents(!Events); }
        else if (path === '/locations') { setHome(!Home); setLocations(!Locations); }
        else if (path === '/FAQs') { setHome(!Home); setMedicare(!Medicare); }
        else if (path === '/about') { setHome(!Home); setAbout(!About); }
        else if (path === '/health-care-provider') { setHome(!Home); }
    }, [location]);

    return (
        <>
            <div className="flex justify-between px-4 sm:px-6 lg:px-8 md:py-3 items-center text-white text-[12px] tracking-widest font-bold border-b border-white/20 shadow-sm bg-brand-red h-12 md:h-8">

                {/* Header-Left-Side */}
                <div className='flex items-center font-bold cursor-pointer my-2 mr-2'>
                    <div className="font-sans">Speak with a Licensed Insurance Agent, M-F 9am-5pm PST   |   <a href="tel:+18008151943" className="text-white hover:underline">1-800-815-1943</a>, TTY 711</div>
                </div>

                {/* Header-Right-Side */}
                <div className='hidden lg:flex font-bold'>
                    <div className='flex items-center no-underline text-white'>
                        <div className="flex cursor-pointer">
                            <div className='flex'>
                                <Link to={'https://paceforboomers.com/'} className="no-underline text-white font-sans text-[14px]">
                                    Pace for Boomers
                                </Link>
                            </div>
                            <span className='mx-3'>|</span>
                            <div className="flex">
                                <button onClick={() => setIsBrokerModalOpen(true)} className="no-underline text-white font-sans text-[14px] bg-transparent border-none cursor-pointer p-0 m-0 hover:text-gray-200">
                                    Agent & Brokers
                                </button>
                                <span className='mx-3'>|</span>
                            </div>
                            <Link to={'/health-care-provider'} className="no-underline text-white font-sans text-[14px]">HealthCare Providers</Link>
                        </div>
                    </div>
                </div>

            </div>

            {/* Nav Bar */}
            <div className="hidden lg:flex justify-between items-center px-8 h-20 bg-white/70 backdrop-blur-2xl sticky top-0 z-50 border-b border-stone-100">
                <Link to={'/'} className='my-3'><img src="/Icons/Logo.svg" alt="" className="h-14" /></Link>
                <div className="flex w-[45rem] justify-between text-sm uppercase tracking-widest font-bold">
                    <Link className={`hover:text-brand-red transition-colors ${Home ? 'text-stone-600' : 'text-brand-red'}`} to={'/'} onClick={() => window.scrollTo(0, 0)}>Home</Link>
                    <Link className={`hover:text-brand-red transition-colors ${FindAnAgent ? 'text-brand-red' : 'text-stone-600'}`} to={'/FindAgent'} onClick={() => window.scrollTo(0, 0)}>Find an Agent</Link>
                    <Link className={`hover:text-brand-red transition-colors ${Events ? 'text-brand-red' : 'text-stone-600'}`} to={'/events'} onClick={() => window.scrollTo(0, 0)}>Events</Link>
                    <Link className={`hover:text-brand-red transition-colors ${Locations ? 'text-brand-red' : 'text-stone-600'}`} to={'/locations'} onClick={() => window.scrollTo(0, 0)}>Locations</Link>
                    <Link className={`hover:text-brand-red transition-colors ${Medicare ? 'text-brand-red' : 'text-stone-600'}`} to={'/FAQs'} onClick={() => window.scrollTo(0, 0)}>Medicare FAQs</Link>
                    <Link className={`hover:text-brand-red transition-colors ${About ? 'text-brand-red' : 'text-stone-600'}`} to={'/about'} onClick={() => window.scrollTo(0, 0)}> About Us</Link>
                </div>
            </div>

            {/* Nav-bar for Mobile */}
            <div className="lg:hidden flex justify-between items-center px-4 h-16 bg-white/70 backdrop-blur-2xl sticky top-0 z-50 border-b border-stone-100">
                {/* Hamburger Icon */}
                <div
                    ref={buttonRef}
                    className="flex flex-col cursor-pointer gap-1 z-30 p-2 rounded hover:bg-gray-100"
                    onClick={() => setIsOpen((prev) => !prev)}
                >
                    <img
                        className="h-8 w-8 transition-all duration-300"
                        src={isOpen ? "/Icons/xmark-solid.svg" : "/Icons/bars-solid.svg"}
                        alt="menu toggle"
                    />
                </div>

                <Link to={'/'} className="flex items-center">
                    <img src="/Icons/Logo.svg" alt="" className="h-12 max-h-full w-auto" />
                </Link>

                <Link to="https://portal.boomersinsuranceservices.com/auth/signin" className="block py-2 bg-red-600 text-white px-3 rounded font-bold hover:bg-red-700 no-underline" onClick={() => setIsOpen(false)}>Login</Link>

                {/* Mobile Menu Dropdown */}
                <nav
                    ref={menuRef}
                    className={`absolute top-16 left-0 w-full bg-white z-20 shadow-xl transition-all duration-300 origin-top overflow-hidden ${isOpen ? "opacity-100" : "max-h-0 opacity-0"}`}
                >
                    <ul className="flex flex-col">
                        <li className="border-b border-gray-100">
                            <Link to="/" className="block px-6 py-4 text-gray-800 text-lg hover:bg-gray-50" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }}>Home</Link>
                        </li>
                        <li className="border-b border-gray-100">
                            <Link to="/FindAgent" className="block px-6 py-4 text-gray-800 text-lg hover:bg-gray-50" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }}>Find an Agent</Link>
                        </li>
                        <li className="border-b border-gray-100">
                            <Link to="/events" className="block px-6 py-4 text-gray-800 text-lg hover:bg-gray-50" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }}>Events</Link>
                        </li>
                        <li className="border-b border-gray-100">
                            <Link to="/locations" className="block px-6 py-4 text-gray-800 text-lg hover:bg-gray-50" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }}>Locations</Link>
                        </li>
                        <li className="border-b border-gray-100">
                            <Link to="/FAQs" className="block px-6 py-4 text-gray-800 text-lg hover:bg-gray-50" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }}>Medicare FAQs</Link>
                        </li>
                        <li className="border-b border-gray-100">
                            <Link to="/about" className="block px-6 py-4 text-gray-800 text-lg hover:bg-gray-50" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }}>About Us</Link>
                        </li>
                        <li className="border-b border-gray-100">
                            <Link to="/health-care-provider" className="block px-6 py-4 text-gray-800 text-lg hover:bg-gray-50" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }}>HealthCare Providers</Link>
                        </li>
                        <li className="border-b border-gray-100">
                            <Link to="https://paceforboomers.com/" className="block px-6 py-4 text-gray-800 text-lg hover:bg-gray-50" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }}>Pace for Boomers</Link>
                        </li>
                    </ul>
                </nav>
            </div>

            {/* Broker Modal */}
            <AnimatePresence>
                {isBrokerModalOpen && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4 bg-black/60 backdrop-blur-sm">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.95 }}
                            transition={{ duration: 0.2 }}
                            className="bg-white rounded-3xl shadow-2xl overflow-hidden max-w-md w-full relative border border-gray-100"
                        >
                            <div className="p-8">
                                <button
                                    onClick={() => setIsBrokerModalOpen(false)}
                                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition-colors bg-transparent border-none cursor-pointer text-xl"
                                >
                                    ✕
                                </button>

                                <div className="text-center mt-2 mb-8">
                                    <h3 className="text-2xl font-extrabold text-gray-900 mb-2">
                                        Welcome to Boomers Agent Portal
                                    </h3>
                                    <p className="text-gray-600 text-sm leading-relaxed">
                                        Choose your path to access training, tools, and support built for Medicare agents.
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <button
                                        onClick={() => {
                                            setIsBrokerModalOpen(false);
                                            window.location.href = 'https://portal.boomersinsuranceservices.com';
                                        }}
                                        className="w-full p-4 bg-white border-2 border-brand-red text-gray-900 font-bold rounded-2xl hover:bg-gray-50 transition-all duration-300 text-left shadow-sm group"
                                    >
                                        <div className="text-lg">I'm an Existing Agent</div>
                                        <div className="text-xs font-normal text-gray-500 group-hover:text-gray-700">
                                            Access your dashboard, leads, and training
                                        </div>
                                    </button>

                                    <button
                                        onClick={() => {
                                            setIsBrokerModalOpen(false);
                                            window.location.href = 'https://portal.boomersinsuranceservices.com/auth/signup';
                                        }}
                                        className="w-full p-4 bg-brand-red text-white font-bold rounded-2xl hover:bg-red-700 transition-all duration-300 text-left shadow-md hover:shadow-lg"
                                    >
                                        <div className="text-lg">Join Boomers as a New Agent</div>
                                        <div className="text-xs font-normal text-red-100">
                                            Get contracted, trained, and start closing
                                        </div>
                                    </button>

                                    <button
                                        onClick={() => {
                                            setIsBrokerModalOpen(false);
                                            window.location.href = 'https://portal.boomersinsuranceservices.com/auth/signup';
                                        }}
                                        className="w-full py-3 px-4 bg-transparent text-gray-500 font-medium rounded-xl hover:text-brand-red transition-colors duration-200 flex items-center justify-center text-sm"
                                    >
                                        Just Exploring? See how Boomers helps agents grow
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </>
    )
}

export default Header
